<template lang="pug">
form(@submit.prevent='onConfirm')
  modal.active(
    :active='showModal'
    @close='$router.back()',
    :title='`Manutenção do documento (${current.numero}/${current.ano})`'
  )
    div(slot='modal-body')
      .toast.toast-error 
        h4 Atenção!
        p Nenhuma regra e/ou cálculo será aplicadao ao salvar, os campos serão salvos com os valores informados.#[br]
          | Após salvar o documento, o sistema registrará as alterações no comentário.
        p Use esta funcionalidade apenas se não houver outra alternativa.
      .divider
      form-group(:label="'doc.situacao' | tModel" :validation="$v.form.doc.situacao_id")
        doc-situacao-picker(v-model="$v.form.doc.situacao_id.$model")
      form-group(:label="'doc.fiscal' | tModel" :validation="$v.form.doc.fiscal_id")
        fiscal-picker(v-model="$v.form.doc.fiscal_id.$model")
      .columns
        form-group.column.col-6.col-md-12(:label="'doc.reincidente' | tModel" :validation="$v.form.doc.reincidente")
          int.form-input(v-model="$v.form.doc.reincidente.$model")
        form-group.column.col-6.col-md-12(:label="'doc.prazo_regularizar' | tModel" :validation="$v.form.doc.prazo_regularizar")
          int.form-input(v-model="$v.form.doc.prazo_regularizar.$model")
        form-group.column.col-4.col-md-12(:label="'doc.regularizar_em' | tModel" :validation="$v.form.doc.regularizar_em")
          datepicker(v-model="$v.form.doc.regularizar_em.$model")
        form-group.column.col-4.col-md-12(:label="'doc.autuado_em' | tModel" :validation="$v.form.doc.autuado_em")
          datepicker(v-model="$v.form.doc.autuado_em.$model")
        form-group.column.col-4.col-md-12(:label="'doc.debito_vence_em' | tModel" :validation="$v.form.doc.debito_vence_em")
          datepicker(v-model="$v.form.doc.debito_vence_em.$model")
      .divider.text-center(data-content='Valores')
      .columns
        .column.col-6.col-md-12(v-for="(valor, index) in form.doc.valores" :key="`${valor.tipo}-${valor.id}`")
          form-group(:label="valor.titulo")
            doc-valor.form-input(v-model="form.doc.valores[index]")
      form-group(:label="'doc.valor_total' | tModel" :validation="$v.form.doc.valor_total")
        money.form-input(v-model="$v.form.doc.valor_total.$model")

      form-group(label="Informe o motivo da manutenção" :validation="$v.form.motivo")
        textarea.form-input(v-model="$v.form.motivo.$model" rows="2")
    div(slot='modal-footer')
      .columns.align-center
        .column.text-error.text-left Após confirmar não será possível desfazer.
        .column.col-auto
          button.btn.btn-primary(
            :disabled='$v.$invalid || loading',
            :class='{ loading }'
          )
            btn-content(name='confirm')
</template>

<script>
import { sanitize, deepClone } from "paliari-js-utils"
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "fiscalizacao/docs": {
      state: ["current"],
      actions: ["fetchManutencao"],
    },
  },
  data() {
    return {
      form: {
        doc: {
          situacao_id: null,
          fiscal_id: null,
          reincidente: null,
          prazo_regularizar: null,
          regularizar_em: null,
          autuado_em: null,
          debito_vence_em: null,
          valores: [],
          valor_total: null,
        },
        motivo: "",
      },
      loading: false,
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        const params = { id, params: this.form }
        await this.fetchManutencao(params)
        this.$toaster.success("Manutenção do documento com sucesso")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    const rules = {
      situacao_id: true,
      fiscal_id: true,
      reincidente: true,
      prazo_regularizar: true,
      regularizar_em: true,
      autuado_em: true,
      debito_vence_em: true,
      valores: true,
      valor_total: true,
    }
    const doc = deepClone(sanitize(this.current, rules))
    this.$set(this.form, "doc", doc)
  },
  validations: {
    form: {
      doc: {
        situacao_id: { required },
        fiscal_id: {},
        reincidente: { required },
        prazo_regularizar: { required },
        regularizar_em: {},
        autuado_em: {},
        debito_vence_em: {},
        valores: {},
        valor_total: { required },
      },
      motivo: {
        required,
        minLength: minLength(10),
      },
    },
  },
}
</script>
